import MainSolutions from "../en/main-solutions.js";
export default MainSolutions;
